import { EContractStatus, EWorkStatus } from '@/httpRequest/modules/novel/list'
import { IListRellItem } from '@/httpRequest/modules/user/listReel'
import play from '@img/components/play.png'
import completed from '@img/components/waterfall/completed.png'
import linked from '@img/components/waterfall/linked.png'
import pay from '@img/components/waterfall/pay.png'
import sign from '@img/components/waterfall/sign.png'
import draft from '@img/personal/drafts2.png'

import styles from '../waterfall.module.less'

interface Props {
  actionEl?: JSX.Element | null
  info?: IListRellItem
  handleRead?: () => void
}

export function VideoItem({ actionEl, info, handleRead }: Props) {
  return (
    // 置顶样式 styles.Pinned
    <div
      className={`${
        info?.is_author_pinned || info?.is_pinned ? styles.Pinned : ''
      } ${styles.waterfallVideoCard}`}
    >
      <div className="hover">
        {/* 图片 */}
        <img src={info?.cover_pic_url} className="pic" />

        {/* 信息 */}
        <div className="infos">
          <div className="sle">{info?.name}</div>
          <p>{info?.author_name}</p>
        </div>

        {/* 播放 */}
        <img src={play} className="play" />

        {/* 详情介绍 */}
        {!actionEl && (
          <div className="intro-detail" onClick={handleRead}>
            <div className="mle">{info?.intro}</div>
          </div>
        )}

        {/* 操作按钮 */}
        {actionEl}
      </div>

      {/* 标签 */}
      <div className="tags">
        {/* 已签约 */}
        {info?.sign_status === EContractStatus.COMPLETED ? (
          <a>
            <img src={sign} />
            <span>Signed</span>
          </a>
        ) : null}

        {/* 已完结 */}
        {info?.is_finish ? (
          <a>
            <img src={completed} />
            <span>Completed</span>
          </a>
        ) : null}
        {/* 付费 */}
        {info?.is_pay ? (
          <a>
            <img src={pay} />
            <span>On Sale</span>
          </a>
        ) : null}
        {/* 链接 */}
        {info?.resource_type === 2 ||
        (info?.resource_type === 3 && info.is_ad) ? (
          <a>
            <img src={linked} />
            <span>External Linked</span>
          </a>
        ) : null}

        {/* 草稿 */}
        {info?.status === EWorkStatus.DRAFT ? (
          <a className="draft">
            <button>
              <img src={draft} />
              DRAFT
            </button>
            <span>DRAFT (only visible to you)</span>
          </a>
        ) : null}
      </div>
    </div>
  )
}
